import { UserSession } from '~/dtos/user_session';
import { handleException } from '~/modules/utilities/cross_env_utils';
import { authenticateUserSession } from '@/services/userSessionService';
import {
  createFetchStore,
  EntityStoreState,
  EntityStoreStatuses,
  selectData as selectUserData,
} from '@/util/createFetchStore';

type SessionStoreState = EntityStoreState<UserSession>;

export const [userSessionStore, useUserSessionStore] = createFetchStore<UserSession>({
  storeName: 'userSessionStore',
  errorStatusOnNullResponse: true,
  fetch: authenticateUserSession,
  handleException: (exception) => handleException(exception, { logLevel: 'warn' }),
});

export function useUser() {
  return useUserSessionStore(selectUser) as unknown as $.User;
}

export function selectUser(state: SessionStoreState) {
  return selectUserData(state);
}

export function selectIsLoggedIn(state = userSessionStore.getState()): boolean {
  return state.status === 'LOADED' && !!state.data?.id;
}

export function selectResetPasswordRequired(state = userSessionStore.getState()): boolean {
  return state.status === 'LOADED' && !!state.data?.resetPassword;
}

export function setUserSession(user: UserSession) {
  userSessionStore.produce(function setUserSession(draft) {
    draft.data = user;
    draft.status = EntityStoreStatuses.LOADED;
  });
}

export function clearUserSession() {
  userSessionStore.reset();
}
